import React, { useState } from "react";
import useClickOutside from "hooks/useClickOutside";
import Input from "components/input";
import ErrorMessage from "components/error-message";
import { ReactComponent as ChevronDown } from "svgs/chevron-down.svg";
import clsx from "clsx/lite";

const PurchasedProducts = ({
	products,
	selectedProducts,
	setSelectedProducts,
	orderFormState,
	setOrderFormState,
	errors,
	setErrors
}) => {
	const [filteredProductTitles, setFilteredProductTitles] = useState(
		products.map((product) => product.title)
	);
	const [dropdownOpen, setDropdownOpen] = useState(false);

	const dropdownRef = useClickOutside(() => setDropdownOpen(false));

	const handleProductSearch = (e) => {
		const query = e.target.value.toLowerCase();
		const availableProducts = products
			.map((product) => product.title)
			.filter((title) => !selectedProducts.includes(title));

		setFilteredProductTitles(
			query
				? availableProducts.filter((title) =>
					title.toLowerCase().includes(query)
				)
				: availableProducts
		);

		setOrderFormState({ ...orderFormState, productTitle: e.target.value });
		setDropdownOpen(true);
	};

	const handleProductSelect = (product) => {
		setErrors((prevErrors) => ({ ...prevErrors, products: null }));
		if (!selectedProducts.includes(product)) {
			setSelectedProducts((prevSelected) => [...prevSelected, product]);
		}
		setOrderFormState((prevState) => ({ ...prevState, productTitle: "" }));
		setDropdownOpen(false);
	};

	return (
		<div className="relative w-full" ref={dropdownRef}>
			<Input
				name="productTitle"
				label="Purchased Products"
				value={orderFormState.productTitle}
				onFocus={() => setDropdownOpen(true)}
				onChange={handleProductSearch}
				autoComplete="off"
				placeholder="Type here to select products"
			/>
			<ChevronDown
				onClick={() => setDropdownOpen(!dropdownOpen)}
				className={clsx(
					"absolute transition-all duration-300 top-5 right-4 cursor-pointer",
					dropdownOpen && "rotate-180"
				)}
			/>
			{errors?.products && <ErrorMessage message={errors.products} />}
			{dropdownOpen && filteredProductTitles.length > 0 && (
				<div className="absolute z-10 bg-white border border-gray-300 rounded-b-lg max-h-44 overflow-y-auto w-full">
					{filteredProductTitles.map(
						(product, index) =>
							!selectedProducts.includes(product) && (
								<div
									key={index}
									className="p-2 hover:bg-gray-100 cursor-pointer"
									onClick={() => handleProductSelect(product)}
								>
									{product}
								</div>
							)
					)}
				</div>
			)}
			{selectedProducts.length > 0 && (
				<div className="mt-2 flex gap-1 flex-wrap">
					{selectedProducts.map((product, index) => (
						<div
							key={index}
							className="flex gap-1 items-center p-1 text-white bg-black"
						>
							<span className="text-xs">{product}</span>
							<button
								className="flex items-center"
								type="button"
								onClick={() =>
									setSelectedProducts((prevSelected) =>
										prevSelected.filter((_, i) => i !== index)
									)
								}
							>
								x
							</button>
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default PurchasedProducts;
